import { v4 as uuid } from 'uuid';

type Opaque<T, K> = T & { _: K };

export type BoardID = Opaque<string, 'BoardID'>;

export const RANDOM_BOARD_ID = 'random' as BoardID;

export function createBoardID(): BoardID {
  return uuid() as BoardID;
}
